'use strict';

import React from 'react';

require('styles//Content.css');

class ContentComponent extends React.Component {
  render() {
    return (
      <div className="content-component">
         <section>
          <h2 className="section-title">Software</h2>
          <div className="software-grid">
            <div className="software">
              <img src="/static/images/parceiros/sage.svg" alt="Sage" />
            </div>
            <div className="software">
              <img src="/static/images/parceiros/zonesoft.png" alt="Zone Soft" />
            </div>
            <div className="software">
              <img src="/static/images/parceiros/xd-software.png" alt="XD Software" />
            </div>
            <div className="software">
              <img src="/static/images/parceiros/moloni.png" alt="Moloni" />
            </div>
            <div className="software">
              <img src="/static/images/parceiros/keymaster.png" alt="Keymaster" />
            </div>
          </div>
        </section>

        <section>
          <h2 className="section-title">A Nossa Missão</h2>
          <p>
            A LABOR TEAM tem como missão libertar o CLIENTE para que concentre todos os seus recursos nas actividades que o distinguem. A nossa equipa é constituída por pessoas especializadas nas suas funções e que gostam do seu trabalho.
          </p>
          <p>
            A LABOR TEAM faz um acompanhamento personalizado presencial, por telefone, por email ou por acesso remoto, adaptando-se às diferentes condições e necessidades de cada CLIENTE. Ajudamos cada CLIENTE a crescer em qualidade, conhecimentos, segurança e fiabilidade e a reduzir os custos administrativos e os custos com software de gestão.
          </p>
        </section>

        <section>
          <h2 className="section-title">Parceiros</h2>
          <div className="partner-grid">
            <div className="partner">
              {/* <a href="http://www.compucais.pt/"> */}
                <img src="/static/images/parceiros/compucais.svg" alt="Compucais" />
              {/* </a> */}
            </div>
            <div className="partner">
              {/* <a href="https://atelierdesoftware.pt/"> */}
                <img src="/static/images/parceiros/atelierdesoftware.svg" alt="Atelier de Software" />
              {/* </a> */}
            </div>
            <div className="partner">
              {/* <a href="https://atelierdesoftware.pt/"> */}
                <img src="/static/images/parceiros/jmsi.png" alt="JMSI" />
              {/* </a> */}
            </div>
            {/* <div className="partner">
              <a href="http://www.sage.pt/"><img src="/static/images/parceiros/sage.svg" alt="Sage"/></a>
            </div>
            <div className="partner">
              <a href="https://www.zonesoft.pt/"><img src="/static/images/parceiros/zonesoft.png" alt="Zone Soft"/></a>
            </div> */}
          </div>
        </section>
      </div>
    );
  }
}

ContentComponent.displayName = 'ContentComponent';

// Uncomment properties you need
// ContentComponent.propTypes = {};
// ContentComponent.defaultProps = {};

export default ContentComponent;



// WEBPACK FOOTER //
// ./src/components/HomeComponent.js